import React, {Component} from 'react'
// import NavBar from './navbar/navbar'
import './About.scss'

import AppFooter from './footer/footer';
import NavBarTest from "./navbar/NavBarTest";
import {Col, Row, Image} from "react-bootstrap";

class About extends Component {


    render() {

        return (
            <React.Fragment>
                {/* <NavBar/> */}
                <NavBarTest/>
                <div className="container">
                    <Row className="jumbotron jumbotron-fluid">
                        <Col xs={12} md={6}>
                            <h1 className="display-4">About Us</h1>
                            <p> Zimble is not just a platform, Zimble in its core believes that students that are
                                passionate about learning, can become better versions of themselves and should not be
                                held back by the limitations of the environment that they are in.
                            </p>
                            <p>
                                Zimble's desire is to not just provide content on the internet, but the desire to
                                provide infastrucuture, technologies, and physical means to students, giving them the
                                opportunity to access the internet.
                            </p>
                        </Col>

                        <Col xs={12} md={6}>
                            <Image src={require('../images/about-us.svg')} fluid/>
                        </Col>
                    </Row>
                </div>

                <Row className="dark">
                    <div className="jumbotron jumbotron-dark container">
                        <p>According to UNESCO, approximately 264 million children globally have no fundamental access
                            to education. COVID-19 only supports an increase in numbers, as such a virus can create a
                            radical shift in human welfare by integrating itself in every aspect of daily living—such as
                            within the realms of economic, political, health, and civic safety. Zimble is one way of
                            targeting an already established crisis experiencing symptoms of a global pandemic. </p>
                    </div>
                </Row>


                <div className="container">
                    <Row className="jumbotron jumbotron-fluid">
                        <Col xs={12} md={6}>
                            <Image src={require('../images/children-learning.svg')} fluid/>
                        </Col>

                        <Col xs={12} md={6}>
                            <p>Access to an education should not be seen as a privilege to have but as an obligation to
                                provide. We have an obligation to ensure children around the world have access to an
                                education regardless of region, religion, or race. Unfortunately, despite all the
                                advancements that have been made worldwide, there are still some countries that have
                                been severely lagging in the area of education. </p>
                            <p>Zimble's desire is to not just provide content on the internet, but the desire to provide
                                infrastructure, technologies, and physical means to students, giving them the
                                opportunity to access the internet.</p>
                        </Col>
                    </Row>
                </div>


                <Row className="dark">
                    <div className="jumbotron jumbotron-dark container">
                        <h1 className="display-4 text-white">Sobering facts</h1>
                        <p>In 39 out of 99 countries, fewer than 50% of the poorest children have completed primary
                            school. More than 50% of young people in 58 out of 133 countries have not completed upper
                            secondary school.</p>
                        <p>Since 2010, in 24 out of 52 countries fewer than 25% of children in rural areas have the
                            opportunity to attend Early childhood care and education</p>
                    </div>
                </Row>


                <div className="container">
                    <Row className="jumbotron jumbotron-fluid">
                        <Col xs={12} md={6}>
                            <p>At Zimble, we wish to provide access to educational content to students around the world
                                by educators from across the world.</p>
                            <p>There is a growing body of empirical research that shows that better education yields
                                higher individual income and contributes towards the construction of social capital and
                                long-term economic growth</p>
                        </Col>

                        <Col xs={12} md={6}>
                            <Image src={require('../images/books-lover.svg')} fluid/>
                        </Col>
                    </Row>
                </div>

                <div className='gradient-half-primary-v1'>
                    <AppFooter/>
                </div>

            </React.Fragment>

        )
    }

}


export default About;